import { BillingTotals, UserSubscription } from "../../../index";

interface UserSubscriptionUpdateProps {
	subscription: UserSubscription;
	immediateTransaction: BillingTotals;
	nextTransaction: BillingTotals;
	recurringTransaction: BillingTotals;
}

class UserSubscriptionUpdate {
	constructor(public _: UserSubscriptionUpdateProps) {}

	static fromFirestore(userSubscription: any) {
		const data = userSubscription.data();
		return UserSubscriptionUpdate.fromJson(data);
	}

	static fromJson(data: any) {
		return new UserSubscriptionUpdate({
			subscription: UserSubscription.fromJson(
				data.subscription
			),
			immediateTransaction: BillingTotals.fromJson(data.immediate_transaction),
			nextTransaction: BillingTotals.fromJson(data.next_transaction),
			recurringTransaction: BillingTotals.fromJson(data.recurring_transaction),
		});
	}

	copyWith(props: Partial<UserSubscriptionUpdateProps>) {
		return new UserSubscriptionUpdate({ ...this._, ...props });
	}

	toJson(withInternalId = true) {
		const data = {
			subscription: this._.subscription.toJson(),
			immediate_transaction: this._.immediateTransaction.toJson(),
			next_transaction: this._.nextTransaction.toJson(),
			recurring_transaction: this._.recurringTransaction.toJson(),
		} as any;
		return data;
	}
}

export { UserSubscriptionUpdate };
